/* eslint-disable */
import { setRouter as setBugsnagRouter, initBugsnag } from './bugsnag.js';
import { initAmplitude, setAmplitudeUser, logAmplitudeEvent } from './amplitude.js';
import { initHotJarAndStartRecording } from './hotjar.js';
import { logGoogleAnalyticsEvent } from './googleAnalytics.js';
import { logPlausibleEvent } from './plausible.js';

/**
 * Main Analytics Module
 * Orchestrates Bugsnag, Amplitude, and Hotjar integrations
 */
const innerObject = {
  debug: window.location.host !== "app.ganttpro.com",
  isEnabled: false,

  /**
   * Set Vue Router for Bugsnag Performance tracking
   */
  setRouter: function (router) {
    setBugsnagRouter(router);
  },

  /**
   * Initialize all analytics services
   */
  init: function () {
    const that = this;

    // Initialize Amplitude
    initAmplitude(that.debug);

    // Initialize Bugsnag (errors + performance)
    initBugsnag(that.debug);

    that.isEnabled = true;

    // Set Amplitude user properties
    if (window.user && window.user.id) {
      setAmplitudeUser(that.debug);
    }
  },

  /**
   * Log event to all analytics services
   */
  log: function (str, obj) {
    const that = this;
    obj = obj || {};

    if (!str) {
      return console.error('[userExtAnalytics] log: nothing to log');
    }

    if (!that.isEnabled) {
      return;
    }

    return setTimeout(function () {
      const services = [];
      
      // Log to each service and track which ones were sent to
      if (window.amplitude) {
        logAmplitudeEvent(str, obj, false);
        services.push('Amplitude');
      }
      
      if (window.dataLayer) {
        logGoogleAnalyticsEvent(str, obj, false);
        services.push('Google Analytics');
      }
      
      if (window.plausible) {
        logPlausibleEvent(str, obj, false);
        services.push('Plausible');
      }

      if (that.debug && services.length > 0) {
        console.info('[Analytics]', str, '->', services.join(' | '));
      }
    }, 0);
  },

  /**
   * Enable logging
   */
  on: function () {
    this.isEnabled = true;
  },

  /**
   * Disable logging
   */
  off: function () {
    this.isEnabled = false;
  },

  /**
   * Initialize Hotjar and start recording
   */
  initHotJarAndStartRecording: initHotJarAndStartRecording,
};

export default innerObject;
